import { DeliveryWindow } from '@typings';

import { showroomApi } from './api';

export const fetchCollections = async (buyer: string, deliveryWindows: DeliveryWindow.Id[]) => {
  return showroomApi.QUERY_POST('/collections')({ data: { buyer, deliveryWindows } });
};
